__turbopack_context__.v({
  "passwordInput": "-cFBVq_passwordInput",
  "passwordInputBody": "-cFBVq_passwordInputBody",
  "policy": "-cFBVq_policy",
  "toggleButton": "-cFBVq_toggleButton",
});
